import { useEffect, useState } from "react";
import BASE_URL from "../BASEURL";

export default function OurJourney() {
  const [journey, setJourney] = useState([]);

  useEffect(() => {
   
  }, []);

  return (
    <section className="py-10  overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* SECTION HEADING */}
        <div
          className="text-center mb-4"
          data-aos="fade-up"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary">
            Our Journey
          </h2>
          <p className="mt-4 text-gray-600 font-body max-w-3xl mx-auto">
            Our journey reflects Sera Water’s commitment to delivering dependable
            water and wastewater treatment solutions while growing alongside
            industries across Ahmedabad and Gujarat.
          </p>
        </div>

        

      </div>
    </section>
  );
}
